/**
 * The type of identification taxonomy used to identify the security.
 * tag: 2375
 * @readonly
 * @enum {string} (char)
 */
export enum TaxonomyType {
  ISINOrAltInstrmtID = 'I',
  InterimTaxonomy = 'E',
}
